import { useState } from "react";
import { Container, Col, Row } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import { BreadcrumbItem } from "reactstrap";
import { useHistory } from "react-router-dom";
import * as Notify from "@repoflow/form-schema/notify";
import * as DomainKeysQL from "queries/domain-key";
import { CancellableContent } from "@repoflow/components/content-cancel";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import * as tags from "@repoflow/form-schema/widgets/tag";
import * as KeyAccess from "components/key-access";
import { Button as ModalButton, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>New</BreadcrumbItem>;


export const Content = ({
  match: {
    params,
    params: { domain },
  },
}) => {
  const [phase, setPhase] = useState("init");
  const [secret, setSecret] = useState(null);
  // The view this key was created from.
  const {
    parent: { base },
  } = useSectionContext();

  const initial = {
    roles: [],
  };
  return (
    <Mutation
      initial={initial}
      context={{
        phase, secret,
        setSecret,
        base,
      }}
      target={{ $ref: "/Public/Key/Create" }}
      mutation={DomainKeysQL.create}
      update={DomainKeysQL.update(params)}
      onMutate={({ state: { values }, handler }) => {
        setPhase("loading");

        // The fields the form shows and nothing else: /Public/Key/Create also
        // lists `scope`, and minting a scoped key is the owning
        // service's job. See components/key-access createInput.
        handler({
          variables: {
            domain,
            input: KeyAccess.createInput(values, ["roles"]),
          },
        });
      }}
      onCompleted={(data) => {
        const keySecret = data.viewer.account.domains.get.keys.create.keySecret;
        setSecret(keySecret);
      }}
      onError={(error) => {
        // Without this the Create button keeps spinning, disabled, forever.
        setPhase("init");
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({
  schema,
  state,
  mutate,
  context: {
    phase,
    secret,
    setSecret,
    base,
  },
  target,
}) => {
  const history = useHistory();
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    onSubmit: () => {
      mutate();
    },
    onChange: (vals) => {
      setValues(vals);
    },
    config: {
      "/Public/Key/Create": {
        fields: [
          "roles"
        ],
      },
    },
    values,
    widgets: { tags }
  };

  const closeSecret = () => {
    setSecret(null)
    history.replace(base);
  }

  return (
    <CancellableContent>
      <Modal isOpen={secret !== null} toggle={closeSecret}>
        <ModalHeader toggle={closeSecret}>API Key Secret</ModalHeader>
        <ModalBody>
          Copy and save your API key secret: <br />
          <b>{secret}</b>
          <br />
          You are not going to see this secret again.
        </ModalBody>
        <ModalFooter>
          <ModalButton color="primary" onClick={closeSecret}>Close</ModalButton>
        </ModalFooter>
      </Modal>

      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit" loading={phase === "loading"}>
                Create
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
